import { ReactNode } from 'react'

export const Heading = ({ children }: { children: ReactNode }) => (
  <h1 className="text-[1.75rem] md:text-6xl font-normal text-primary md:font-black leading-[2.2rem] md:leading=[1]">
    {children}
  </h1>
)
